export const DISABLED_COLOR = '#aaa'
export const ENABLED_COLOR = 'black'
